import { isRunningInBrowser } from '@sleepstation/utils'
import { isNotNil } from 'ramda-adjunct'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import authenticationService from '../services/authenticationService'

// -----------------------------------------------------------------------------
// Hook
// -----------------------------------------------------------------------------

const useIsAuthorsed = (config) => {
  const needsAuthorisation = isNotNil(config)

  const [isAuthorised, setIsAuthorised] = useState(!needsAuthorisation)
  const navigate = useNavigate()

  useEffect(() => {
    if (needsAuthorisation && isRunningInBrowser()) {
      authenticationService
        .authenticate(navigate, config)
        .then(() => {
          setIsAuthorised(true)
        })
        .catch(() => {
          setIsAuthorised(false)
        })
    }
  }, [config, needsAuthorisation, navigate])

  if (needsAuthorisation && !isRunningInBrowser()) return false

  return isAuthorised
}

export default useIsAuthorsed
